const config = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID_PROD,
    authority: process.env.REACT_APP_AUTHORITY_PROD,
    redirectUri: process.env.REACT_APP_REDIRECT_URI_PROD,
  },
}

export default config
